export function validateJson(jsonObj: object, schema: object) {
  const Validator = require('jsonschema').Validator;
  const v = new Validator();

  return v.validate(jsonObj, schema);
}
